// Risk-register findings API client. Mirrors dataDictionaryFindingsApi
// so the G3.7 resolver panels stay consistent.

export const RR_INVARIANT_ID = 'PEG-RISK-REGISTER-FLOOR-001'

export interface RiskRegisterFloorFinding {
  severity: string
  message: string
  actual_rows: number
  floor: number
  deficit: number
  breakdown: Record<string, number>
  finding_key: string
  waived: boolean
  waiver_justification: string | null
}

export interface RiskRegisterFindingsResponse {
  finding: RiskRegisterFloorFinding | null
  risk_register_present: boolean
}

const API_BASE = '/api'

function getOrCreateClientId(): string {
  const KEY = 'ai_alm.client_id'
  try {
    let id = window.localStorage.getItem(KEY)
    if (!id) {
      id = `c_${Math.random().toString(36).slice(2, 10)}_${Date.now()}`
      window.localStorage.setItem(KEY, id)
    }
    return id
  } catch {
    return 'c_anonymous'
  }
}

function newRequestId(): string {
  return `r_${Math.random().toString(36).slice(2, 10)}`
}

async function jsonFetch<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(`${API_BASE}${path}`, {
    ...init,
    headers: {
      'Content-Type': 'application/json',
      'X-Client-Id': getOrCreateClientId(),
      'X-Request-Id': newRequestId(),
      ...(init?.headers ?? {}),
    },
  })
  if (!response.ok) {
    let detail = ''
    try {
      const envelope = await response.json()
      detail =
        envelope?.error?.message ??
        envelope?.detail ??
        response.statusText ??
        `HTTP ${response.status}`
    } catch {
      detail = response.statusText || `HTTP ${response.status}`
    }
    throw new Error(detail)
  }
  return (await response.json()) as T
}

export function getRiskRegisterFindings(
  projectId: string,
  runId: number,
): Promise<RiskRegisterFindingsResponse> {
  return jsonFetch(
    `/projects/${projectId}/runs/${runId}/risk-register-findings`,
  )
}
